import { ref } from 'vue';
import { reembolsoApi } from '@/services/reembolsoApi';

/**
 * §12 — Flag "sou conferente do financeiro". Resolvida uma única vez por sessão
 * via GET /reembolso/sou-conferente e cacheada em nível de módulo (mesmo padrão do
 * useUserCache). `null` = ainda carregando (evita flicker no menu/abas).
 */
const isConferente = ref<boolean | null>(null);
let loadPromise: Promise<void> | null = null;

async function load() {
  if (loadPromise) return loadPromise;
  loadPromise = (async () => {
    try {
      const res = await reembolsoApi.souConferente();
      isConferente.value = Boolean(res.isConferente);
    } catch {
      isConferente.value = false;
    }
  })();
  return loadPromise;
}

export function useReembolsoConferenteFlag() {
  load();
  return { isConferente };
}
